import { ProductType } from './models';

export const PRODUCT_TYPE_ROUTE_MAP = new Map<ProductType, string>([
  [ProductType.RemoteSigning, 'ron'],
  [ProductType.Hybrid, 'hybrid'],
  [ProductType.IPEN, 'ipen'],
  [ProductType.KRON, 'kron'],
]);
